import { createContext, type ComponentType } from 'react';

import type { Live } from '@/lib/limulo/partiteInCorso';

/**
 * LE PROPS DELLA LIVE DELLA HUB che il pannello `CrLiveLimuloPanel` passa a una vista alternativa, quando qualcuno sopra di lui ne ha messa una nel Context. Le passa solo nei due casi in cui il pannello ha delle cose da dire: `rows` e `empty`
 * (loading, lentezza, errore e fonte spenta restano i `PanelWaiting` e `PanelNotice` di oggi: i cinque casi non si riscrivono).
 *
 * @param vuoto il verdetto e' `empty` (nessuna partita, a fonti tutte risposte): la vista dice «niente da guardare». Altrimenti `live.totale > 0`.
 * @param live tutte le partite in corso, SENZA filtri (la vista alternativa non ha i filtri di oggi) e con le mie dentro (`mie` + `sezioni`).
 * @param ora l'istante del ridisegno di `OROLOGIO_LIVE_MS`, per il «da N min»: il pannello lo tiene, cosi' c'e' un orologio solo.
 * @param oltre quante partite il motore ha contato oltre la pagina letta; `troncata` = il motore ha smesso di contare, e allora e' un minimo.
 * @param gameIds i `gameId` del catalogo che sono Clash Royale: la vista ci legge i tornei di oggi nel vuoto.
 */
export interface PropsLiveHub {
  vuoto: boolean;
  live: Live;
  ora: number;
  oltre: number;
  troncata: boolean;
  gameIds: readonly string[];
}

/**
 * IL PUNTO D'INNESTO di una Live alternativa (fase 3, PR 5; stesso schema di `SlotListaTornei`). Il valore di partenza e' `null`: senza nessuno sopra, `CrLiveLimuloPanel` rende quello di sempre e il DOM non cambia di un nodo.
 * ⛔ Il valore di partenza resta `null`: un componente di default farebbe cambiare il pannello per chiunque, anche dove nessuno l'ha scelto.
 */
export const SlotLiveHub = createContext<ComponentType<PropsLiveHub> | null>(null);
